export default balance => {
    if(balance < 250)
        return [50, 100, 150, 200];

    const ticks = Math.floor(balance / 25);

    return [
        Math.round(25 * Math.floor(ticks / 4)),
        Math.round(25 * (Math.floor(ticks / 4) + 4)),
        Math.round(25 * (Math.floor(ticks / 4) + 8)),
        Math.round(25 * (Math.floor(ticks / 4) + 12)),
    ]
}